import * as React from 'react';

/**
 * Detect double press (mostly for web UX).
 */
export function useDoubleClick(
    onDoubleClick: (event: React.MouseEvent) => void,
    onSingleClick?: (event: React.MouseEvent) => void,
    delay = 500 // default double click speed on Windows
): (event: React.MouseEvent) => void {
    const clickTimeout = React.useRef<NodeJS.Timeout | null>(null);

    return (event: React.MouseEvent) => {
        if (clickTimeout.current) {
            clearTimeout(clickTimeout.current);
            clickTimeout.current = null;
            onDoubleClick(event);
        } else {
            clickTimeout.current = setTimeout(() => {
                clickTimeout.current = null;
                onSingleClick?.(event);
            }, delay);
        }
    };
}
